import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PRIMARY_LANG } from "Common/constant";
import service from '../../utils/service';

export const initialState = {
  loading: false,
  user_details: { role: "Guest", baseUrl: "/guest-user" },
  account_details: { role: "Guest", baseUrl: "/guest-user" },
  user_details_error: {},
  account_details_error: {},
  token: {},
  signupPage:false,
  signupStepper : 0,
  upComingPath:"",
  recentRoutes:"",
  networkError : false,
  tzValidated: false,
  guest_uuid:"",
  includePrimeLang: false,
  isRoleSelected: false,
  isMultipleRolePresent: false,
};
const loginReducer = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginAccessToken(state, { payload }) {
      state.user_details = { ...state.user_details, access_token: payload };
    },
    accountAccessToken(state, { payload }) {
      state.account_details = { ...state.account_details, access_token: payload };
    },
    accountDetailsUpdate(state, { payload }) {
      state.account_details = { ...state.account_details, ...payload };
    },
    userDetailsUpdate(state, { payload }) {      
      state.user_details = { ...state.user_details, ...payload };
    },
    setBaseUrl(state, action) {
      let { user_details } = state;
      if (user_details) {
        let { is_appointment_booked = false, is_membership_active = false, is_membership_expired = false, membership_expiry_date, membership_type = "", is_socio_demographic = false, is_evaluated = '', is_membership_benefits_availed= '', membership_benefits_availed_date ='', display_plan_name="" } = user_details || {};
        localStorage.setItem("subscription", JSON.stringify({ is_evaluated, is_appointment_booked, is_membership_active, is_membership_expired, membership_expiry_date, membership_type, is_socio_demographic, is_membership_benefits_availed, membership_benefits_availed_date, display_plan_name }))
        user_details.baseUrl = action.payload;
      }

      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },

    setSubScribeData(state, action) {
      let { user_details } = state;
      if (user_details)
        user_details.is_subscribed = action.payload;
      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },
    setEvaluationData(state, action) {
      let { user_details } = state;
      if (user_details)
        user_details.is_evaluation_eligible = action.payload;
      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },
    setIsSocioData(state, action) {
      let { user_details } = state;
      if (user_details)
        user_details.is_socio_demographic = action.payload;
      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },
    setTimeZoneOffset(state, action) {
      let { user_details } = state;
      if (user_details)
        user_details.time_zone_offset_in_min = action.payload;
      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },
    signUpPage(state, action){
      state.signupPage = action.payload;
    },
    signUpStepper(state, action){
      state.signupStepper = action.payload;
    },
    upComingPath(state, action){
      state.upComingPath = action.payload;
    },
    recentRoutes(state, action){
      state.recentRoutes = action.payload;
    },
    setNetworkDrop(state, { payload }) {
      state.networkError = payload;
    },
    setTZValidated(state, { payload }) {
      state.tzValidated = payload;
    },
    setLanguage(state, { payload }) {
      state.includePrimeLang = payload.includePrimeLang;
      state.user_details = { ...state.user_details, language: payload.language };
    },
    setGuestUUID(state, { payload }) {
      state.guest_uuid = payload;
    },
    setRoleSelected(state, { payload }) {
      state.isRoleSelected = payload.isRoleSelected;
      state.user_details = {
        ...state.user_details,
        role: payload.role,
      };
    },
    setMultipleRolePresent(state, { payload }) {
      state.isMultipleRolePresent = payload.isMultipleRolePresent;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase("login/getData/fulfilled", (state, { payload }) => {
        state.user_details = payload?.data || state.user_details;
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("otp-login/otp-getData/fulfilled", (state, { payload }) => {
        state.user_details = payload?.data || state.user_details;
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("login/getAccountData/fulfilled", (state, { payload }) => {
        state.account_details = payload?.data || state.account_details;
        state.account_details_error = {};
        state.user_details = payload?.data || state.user_details;
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("login/getStatus/fulfilled", (state, { payload }) => {
        let login_data = "";
        if(payload?.data?.log_in_response?.name){
          login_data = {
            ...payload?.data["phi"],
            ...payload?.data["time_zone"],
            ...payload?.data["membership"],
            ...payload?.data["log_in_response"]
          }
          state.user_details = payload?.data ? { access_token : state.user_details?.access_token, refresh_token : state.user_details?.refresh_token, ...login_data } : state.user_details;
        }else{ 
          login_data = payload?.data;
          state.user_details = payload?.data ? { access_token : state.account_details?.access_token, refresh_token : state.account_details?.refresh_token, ...login_data } : state.account_details;
        }
        state.account_details = payload?.data ? { access_token : state.account_details?.access_token, refresh_token : state.account_details?.refresh_token, ...login_data } : state.account_details;
        state.account_details_error = {};
        
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("login/getData/pending", (state, action) => {
        state.loading = true;
      })
      .addCase("otp-login/otp-getData/pending", (state, action) => {
        state.loading = true;
      })
      .addCase("login/getAccountData/pending", (state, action) => {
        state.loading = true;
      })
      .addCase("login/getStatus/pending", (state, action) => {
        state.loading = true;
      })
      .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state, { payload }) => {
          state.user_details = {};
          state.user_details_error = payload;
          state.loading = false;
        })

  },
});
export const { setBaseUrl, loginAccessToken, setSubScribeData, setEvaluationData, setIsSocioData, signUpPage, signUpStepper , accountAccessToken,upComingPath,recentRoutes,  setNetworkDrop, setTZValidated, setLanguage, setGuestUUID, setTimeZoneOffset, accountDetailsUpdate, setRoleSelected, setMultipleRolePresent, userDetailsUpdate} = loginReducer.actions;

export const getLoginData = createAsyncThunk(
  "login/getData",
  async ({ url, data }, thunkAPI) => {
    try {
      // const source = axios.CancelToken.source();
      // thunkAPI.signal.addEventListener("abort", () => {
      //   source.cancel();
      // });
      // const response = await axios.post(url, sendData, {
      //   cancelToken: source.token,
      // });
      const response = await service.post(url, data);
      return response?.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getAccountData = createAsyncThunk(
  "login/getAccountData",
  async ({ url, data }, thunkAPI) => {
    try {
      const response = await service.post(url, data);
      return response?.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getOtpLoginData = createAsyncThunk(
  "otp-login/otp-getData",
  async ({ url, data }, thunkAPI) => {
    try {
      // const source = axios.CancelToken.source();
      // thunkAPI.signal.addEventListener("abort", () => {
      //   source.cancel();
      // });
      // const response = await axios.post(url, sendData, {
      //   cancelToken: source.token,
      // });
      const response = await service.post(url, data);
      return response?.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getStatus = createAsyncThunk(
  "login/getStatus",
  async ({ url, data, role }, thunkAPI) => {
    try {
      let response = await service.get(url, data);
      let updated_response = response?.data;
      if(role== "patient"){
        updated_response.data.log_in_response.role = role;
      }else{
        updated_response.data.role = role;
      }
      return updated_response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export default loginReducer.reducer;
